import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { HabitsProvider } from './contexts/HabitsContext';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import InteractiveTutorial from './components/InteractiveTutorial';
import AppTour from './components/AppTour';
import './App.css';
import './styles.css';
import './debug';

const AppContent: React.FC = () => {
  const { currentUser, loading } = useAuth();
  const [showInteractiveTutorial, setShowInteractiveTutorial] = useState(false);
  const [showAppTour, setShowAppTour] = useState(false);

  // Verificar se é o primeiro acesso do usuário
  useEffect(() => {
    if (currentUser) {
      const hasSeenTutorial = localStorage.getItem(`tutorial_seen_${currentUser.uid}`);
      if (!hasSeenTutorial) {
        setShowInteractiveTutorial(true);
      }
    }
  }, [currentUser]);

  const handleAuthSuccess = () => {
    // Auth success is handled automatically by the context
  };

  const handleTutorialComplete = () => {
    setShowInteractiveTutorial(false);
    if (currentUser) {
      localStorage.setItem(`tutorial_seen_${currentUser.uid}`, 'true');
    }
  };

  const handleStartAppTour = () => {
    setShowInteractiveTutorial(false);
    setShowAppTour(true);
    if (currentUser) {
      localStorage.setItem(`tutorial_seen_${currentUser.uid}`, 'true');
    }
  };

  const handleAppTourComplete = () => {
    setShowAppTour(false);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Carregando...
      </div>
    );
  }

  if (!currentUser) {
    return <Auth onAuthSuccess={handleAuthSuccess} />;
  }

  return (
    <>
      <Dashboard />
      
      {/* Tutorial Interativo */}
      <InteractiveTutorial
        isOpen={showInteractiveTutorial}
        onComplete={handleTutorialComplete}
        onStartAppTour={handleStartAppTour}
      />

      {/* Tour do App */}
      <AppTour
        isActive={showAppTour}
        onComplete={handleAppTourComplete}
      />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <HabitsProvider>
        <div className="App">
          <AppContent />
        </div>
      </HabitsProvider>
    </AuthProvider>
  );
}

export default App;
